import { useState } from 'react';
import Header from '../Components/Header.tsx';
import Sidebar from '../Components/Sidebar.tsx';
import './Profile.css';
import useAuth from '../hooks/useAuth.ts';
import { ToastContainer } from 'react-toastify';

function Profile() {
  const { name: userName, email: userEmail } = useAuth();
  const [showSidebar, setShowSidebar] = useState(true);

  return (
    <section className="section">
      <div className="profile">
        <Header title="My Profile" setShowSidebar={setShowSidebar} showSidebar={showSidebar} />
        <ToastContainer />
        <div className="container">
          <div
            className="sidebarStyle"
            style={{
              width: showSidebar ? '240px' : '0',
              transition: 'width 0.3s',
            }}
          >
            <Sidebar />
          </div>
          <div className="mainContentStyle">
            <div className="profileContent">
              <div className="profileField">
                <span className="profileLabel">Full name</span>
                <span className="profileValue">{userName || 'name'}</span>
              </div>
              <div className="profileField">
                <span className="profileLabel">Email</span>
                <span className="profileValue">{userEmail || 'email'}</span>
              </div>
              <div className="authNotice">
                <p className="authNoticeText">
                  <strong>Authentication:</strong> Microsoft Azure AD
                </p>
                <p className="authNoticeText">
                  To change your password or manage account settings, please use your organization's Microsoft account portal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Profile;
